module.exports = __webpack_public_path__ + "static/media/initials-sign.b213dd04.jpg";